// components/CodeBlock.js
import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeBlock = ({ code, language, showLineNumbers = true }) => {
  // Customize the VSC Dark Plus theme with Cinder colors
  const customStyle = {
    ...vscDarkPlus,
    'pre[class*="language-"]': {
      ...vscDarkPlus['pre[class*="language-"]'],
      background: '#1E1E1E',
      padding: '1.5rem',
      margin: '0',
      overflow: 'auto',
      borderRadius: '0',
    },
    'code[class*="language-"]': {
      ...vscDarkPlus['code[class*="language-"]'],
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: '14px',
      lineHeight: '1.5',
    },
    // Customize colors for specific tokens
    comment: {
      ...vscDarkPlus.comment,
      color: '#6A9955'
    },
    string: {
      ...vscDarkPlus.string,
      color: '#FF9B45' // Cinder primary-light
    },
    keyword: {
      ...vscDarkPlus.keyword,
      color: '#D5451B' // Cinder primary
    },
    function: {
      ...vscDarkPlus.function,
      color: '#DCDCAA'
    },
    boolean: {
      ...vscDarkPlus.boolean,
      color: '#D5451B' // Cinder primary
    },
    number: {
      ...vscDarkPlus.number,
      color: '#FF9B45' // Cinder primary-light
    },
    operator: {
      ...vscDarkPlus.operator,
      color: '#D4D4D4'
    },
    punctuation: {
      ...vscDarkPlus.punctuation,
      color: '#D4D4D4'
    },
    property: {
      ...vscDarkPlus.property,
      color: '#9CDCFE'
    },
    'class-name': {
      ...vscDarkPlus['class-name'],
      color: '#4EC9B0'
    },
    variable: {
      ...vscDarkPlus.variable,
      color: '#9CDCFE'
    },
  };

  return (
    <div className="code-block">
      <SyntaxHighlighter 
        language={language} 
        style={customStyle} 
        showLineNumbers={showLineNumbers}
        wrapLines={true}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeBlock;